import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles/Header.module.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const usuario = localStorage.getItem('usuario');
    const permissoes = JSON.parse(localStorage.getItem('permissoes'));

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('usuarioId');
        localStorage.removeItem('permissoes');
        navigate('/login');
    };

    return (
        <header className={styles.header}>
            <div className={styles.esquerda}>
                <a href="https://provin.ind.br/home" rel="noopener noreferrer">
                    <img src="/images/common/provin_joias.png" alt="" />
                </a>
            </div>

            <div className={styles.direita}>
                {location.pathname === '/produtos' && permissoes.produtos.info_addSacola && (
                    <div className={styles.sacola}>
                        <button onClick={() => navigate('/produtos/sacola')}>
                            <img src="images/common/sacola.ico" alt="Sacola"></img>
                        </button>
                    </div>
                )}

                <div className={styles.usuario}>
                    <p>{usuario}</p>
                    <button onClick={handleLogout}>Sair</button>
                </div>
            </div>
        </header>
    );
};

export default Header;